import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider, Helmet } from "react-helmet-async";
import "./App.css";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Hero from "./components/Hero";
import Boutique from "./pages/Boutique";
import Products from "./components/Selection";
import Contact from "./components/Contact";
import Panier from "./pages/Panier";
import CategoryProducts from "./pages/CategoryProducts";
import About from "./components/About";
import Admin from "./pages/Admin";
import Login from "./pages/Login";
import ProductDetail from "./pages/ProductDetail";
import { CartProvider } from "./pages/js/CartContext";
import { AuthProvider } from "./pages/js/AuthContext";

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <div className="App">
              <Header />
              <Routes>
              <Route
                path="/"
                element={
                  <>
                    <Helmet>
                      <title>Accueil - Déco Ariège</title>
                      <meta name="description" content="Boutique artisanale de décoration en bois, objets faits main, idées cadeaux et créations uniques en Ariège. Livraison rapide et fabrication locale." />
                    </Helmet>
                    <main className="App-main">
                    {/* <div className="section white"> */}
                    <Hero />
                    {/* </div> */}
                    <div className="home-section-gray">
                      <Products />
                    </div>
                    <div className="home-section-atelier atelier-presentation">
                      <h2 className="section-title">MON ATELIER</h2>
                      <p className="atelier-description">Mon espace de création où la magie opère !</p>
                      {/* <p className="atelier-description">Chaque pièce est réalisée avec passion et précision.</p> */}
                      <div className="atelier-images">
                        <img
                          src={require("./images/20251212_191037.jpg")}
                          alt="Atelier présentation 1"
                          className="atelier-photo"
                        />
                        <img
                          src={require("./images/20251212_191133.jpg")}
                          alt="Atelier présentation 2"
                          className="atelier-photo"
                        />
                      </div>
                    </div>
                    <div className="home-section-white">
                      <About />
                      <Contact />
                    </div>
                  </main>
                  </>
                }
              />
              <Route path="/boutique" element={<Boutique />} />
              <Route
                path="/boutique/:categoryId/:productId"
                element={<ProductDetail />}
              />
              <Route
                path="/boutique/:category"
                element={<CategoryProducts />}
              />
              <Route path="/panier" element={<Panier />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/login" element={<Login />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
            <Footer />
          </div>
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
    </HelmetProvider>
  );
}
export default App;
